export default __webpack_public_path__ + "static/summary-graph-891422082e5a305b60b1eb79e50d5d95.png";